import { OrderPaymentRecipient } from "generated/dist/private/types";
import {
  CurrencyCode,
  CountryCode,
  Weekday,
} from "generated/dist/public/types";

export const CURRENCY_LABELS = {
  [CurrencyCode.Pln]: "zł",
  [CurrencyCode.Uah]: "грн",
  [CurrencyCode.Czk]: "Kč",
  [CurrencyCode.Eur]: "€",
  [CurrencyCode.Usd]: "$",
};

export const MAP_COUNTRY_CODE_TO_LABEL = {
  [CountryCode.Ua]: "Україна",
  [CountryCode.Pl]: "Польща",
  [CountryCode.It]: "Італія",
  [CountryCode.Cz]: "Чехія",
  [CountryCode.De]: "Німеччина",
  [CountryCode.Ro]: "Румунія",
  [CountryCode.Bg]: "Болгарія",
  [CountryCode.Sk]: "Словаччина",
  [CountryCode.Hu]: "Угорщина",
  [CountryCode.Be]: "Бельгія",
  [CountryCode.Nl]: "Нідерланди",
  [CountryCode.Fr]: "Франція",
  [CountryCode.At]: "Австрія",
  [CountryCode.Lt]: "Литва",
  [CountryCode.Lv]: "Латвія",
  [CountryCode.Ee]: "Естонія",
  [CountryCode.Es]: "Іспанія",
  [CountryCode.Lu]: "Люксембург",
  [CountryCode.Ch]: "Швейцарія",
  [CountryCode.Gr]: "Греція",
  [CountryCode.Md]: "Молдова",
};

export enum SOCIAL_NETWORK {
  FACEBOOK = "facebook",
  INSTAGRAM = "instagram",
  PINTEREST = "pinterest",
  YOUTUBE = "youtube",
}

export const MAP_ORDER_PAYMENT_RECIPIENT_TO_LABEL_ID = {
  [OrderPaymentRecipient.PrexSell]: "PREXSELL",
  [OrderPaymentRecipient.Agent]: "agent",
  [OrderPaymentRecipient.Carrier]: "carrier",
} as const;

export const DATE_VALUE_FORMAT = "DD-MM-YYYY";
export const TAB_DATE_LABEL_FORMAT = "dd, D";

export const DISPATCHER_MTC = "+38 095 005 50 60";
export const DISPATCHER_VODAFON = '+38 095 0055 060';
export const DISPATCHER_LIFECELL = "+38 073 005 50 60";
export const DISPATCHER_KYIVSTAR = "+38 097 005 50 60";
export const DISPATCHER_POLAND = "+48 226 022 360";
export const DISPATCHER_POLAND_2 = "+48 800 003 060";
export const DEUTSHLAND_POLAND = "+49 561 510 099 90";

export const DISPATCHERS_PHONES = [
  DISPATCHER_VODAFON,
  DISPATCHER_POLAND,
  DISPATCHER_POLAND_2,
  DEUTSHLAND_POLAND,
];

export enum PHONE_SOURCE {
  VODAFONE = "Vodafone",
  LIFECELL = "Lifecell",
  KYIVSTAR = "Kyivstar",
  POLAND = "Poland",
  GERMANY = "Germany",
  CZECH = "Czech",
}

export const PHONES_CODES = [
  { code: "38050", source: PHONE_SOURCE.VODAFONE },
  { code: "38066", source: PHONE_SOURCE.VODAFONE },
  { code: "38095", source: PHONE_SOURCE.VODAFONE },
  { code: "38099", source: PHONE_SOURCE.VODAFONE },
  { code: "38063", source: PHONE_SOURCE.LIFECELL },
  { code: "38073", source: PHONE_SOURCE.LIFECELL },
  { code: "38093", source: PHONE_SOURCE.LIFECELL },
  { code: "38067", source: PHONE_SOURCE.KYIVSTAR },
  { code: "38068", source: PHONE_SOURCE.KYIVSTAR },
  { code: "38096", source: PHONE_SOURCE.KYIVSTAR },
  { code: "38097", source: PHONE_SOURCE.KYIVSTAR },
  { code: "38098", source: PHONE_SOURCE.KYIVSTAR },
  { code: "48", source: PHONE_SOURCE.POLAND },
  { code: "49", source: PHONE_SOURCE.GERMANY },
  { code: "420", source: PHONE_SOURCE.CZECH },
];

export const WEEKDAYS = [
  {
    day: Weekday.Monday,
    label: "Понеділок",
  },
  {
    day: Weekday.Tuesday,
    label: "Вівторок",
  },
  {
    day: Weekday.Wednesday,
    label: "Середа",
  },
  {
    day: Weekday.Thursday,
    label: "Четвер",
  },
  {
    day: Weekday.Friday,
    label: "П'ятниця",
  },
  {
    day: Weekday.Saturday,
    label: "Субота",
  },
  {
    day: Weekday.Sunday,
    label: "Неділя",
  },
];

export const LIQPAY_VERSION = 3;
export const LIQPAY_COMMISSION = 0.015;
export const LIQPAY_ACTION = "pay";
export const LIQPAY_FORM_ACTION_URL = "https://www.liqpay.ua/api/3/checkout";
export const LIQPAY_SERVER_ACTION_URL = LIQPAY_FORM_ACTION_URL.replace(
  "3/checkout",
  "request"
);
